module.exports = __webpack_public_path__ + "img/portfolio-dbs.a213439d.jpg";